var React = require('react');

function MoreButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm5-9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-6 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z","fill":"#fff"}));
}

MoreButton.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MoreButton;

MoreButton.default = MoreButton;
